import React from "react";
import { motion } from "framer-motion";

const Experience = () => {
  const experiences = [
    {
      title: "Software & Data Engineer Intern",
      company: "ValueInfinity Inc.",
      location: "Mississauga, ON",
      date: "May 2026 – Present",
      bullets: [
        "Engineered natural language semantic search by integrating Qdrant vector DB with all-MiniLM-L6-v2 embeddings",
        "Reduced knowledge review overhead by integrating Gemini AI to auto-summarize lessons into actionable briefs",
        "Delivered zero-manual-intervention deployments by building GitHub Actions CI/CD pipeline targeting Azure App Service",
        "Instrumented production Node.js backend with Azure Application Insights, enabling live request tracing and exception monitoring",
      ],
      tags: ["Qdrant", "Vector DB", "Gemini AI", "GitHub Actions", "CI/CD", "Azure App Service", "Node.js", "Azure Application Insights"],
    },
    {
      title: "AI & Data Intern",
      company: "Scalefiniti",
      location: "Mississauga, ON",
      date: "April 2025 – September 2025",
      bullets: [
        "Built an n8n LinkedIn pipeline sourcing trending content and generating daily post drafts, saving 2+ hours daily",
        "Integrated Microsoft Teams for one-click draft approval and automatic publishing with no manual steps",
        "Built an n8n AI agent booking, cancelling, and rescheduling calendar events with 100% accuracy, saving ~1hr daily",
        "Extended the agent to send professionally formatted emails via voice command, eliminating manual composition",
      ],
      tags: ["n8n", "Automation", "AI Agents", "Microsoft Teams", "LinkedIn API", "Workflows", "JSON"],
    },
  ];

  return (
    <section className="experience">
      <motion.h3
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        Experience
      </motion.h3>
      <p className="experience-subtitle">
        A quick look at my tech experience history.
      </p>

      <div className="experience-timeline" aria-label="Experience timeline">
        {experiences.map((exp, index) => {
          const sideClass = index % 2 === 0 ? "left" : "right";
          const num = String(index + 1).padStart(2, "0");
          return (
            <motion.div
              key={exp.title + exp.company}
              className={`experience-row ${sideClass}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.12, duration: 0.55 }}
              whileHover={{ y: -3 }}
              viewport={{ once: true }}
            >
              <div className="experience-badge" aria-hidden="true">
                {num}
              </div>

              <article className="experience-card">
                <div className="experience-card-header">
                  <div>
                    <h4 className="experience-title">{exp.title}</h4>
                    <p className="experience-company">
                      {exp.company} &mdash; {exp.location}
                    </p>
                  </div>
                  <span className="experience-date">{exp.date}</span>
                </div>

                <ul className="experience-bullets">
                  {exp.bullets.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>

                <div className="experience-tags" aria-label={`${exp.title} tags`}>
                  {exp.tags.map((t) => (
                    <span key={t} className="experience-tag">
                      {t}
                    </span>
                  ))}
                </div>
              </article>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default Experience;
